export type HomepageFaqEntry = {
  question: string;
  answer: string;
};

/**
 * The homepage FAQ. The same strings feed the visible answers and the
 * FAQPage structured data, which must match the page word for word, so the
 * answers stay plain text.
 */
export const HOMEPAGE_FAQ: HomepageFaqEntry[] = [
  {
    question: 'What is Fantasy Football Hub?',
    answer:
      'The AI and expert platform for Fantasy Premier League managers. Rate your team, get transfer recommendations built around your squad, and read tips and team reveals from the best FPL managers in the world.'
  },
  {
    question: 'How does the AI Team Rating work?',
    answer:
      'Add your squad by searching for your FPL team name or ID, importing a screenshot, or building it on the pitch. Our AI rates the team, flags the players costing you points and shows the transfers that fix it before the next deadline.'
  },
  {
    question: 'Is the AI Team Rating free?',
    answer:
      'Yes. Rating your team is free and needs no card details. We ask for your email to show your result, along with weekly FPL tips you can unsubscribe from at any time.'
  },
  {
    question: 'What do paid plans add?',
    answer:
      "Starter adds AI transfer picks specific to your team every week. Pro adds weekly team reveals from the world's best managers, the AI's team every week and our winners' WhatsApp community. Ultra adds a monthly review of your team by a top FPL manager."
  },
  {
    question: 'Does it work with my FPL account?',
    answer:
      'Yes. Find your team by its FPL team name or ID and the Hub builds its ratings, predictions and transfer picks around the squad you actually have.'
  }
];
